import React, { PureComponent } from "react";
import Select from "react-select";

class SelectField extends PureComponent {
  static defaultProps = {
    placeholder: "",
    options: [],
  };

  handleChange = (selectedOption) => {
    const { onChange } = this.props;
    onChange(selectedOption);
  };

  componentDidMount() {
    const { defaultValue } = this.props;
    defaultValue && this.handleChange(defaultValue);
  }

  render() {
    const { value, name, placeholder, options, isSearchable } = this.props;

    return (
      <Select
        name={name}
        value={value}
        onChange={this.handleChange}
        options={options}
        clearable={false}
        className="react-select"
        placeholder={placeholder}
        classNamePrefix="react-select"
        isSearchable={isSearchable ? isSearchable : false}
        menuPosition={"fixed"}
      />
    );
  }
}

const renderSelectField = (props) => {
  const {
    input,
    meta,
    options,
    placeholder,
    className,
    defaultValue,
    isSearchable,
  } = props;
  return (
    <div className={`form__form-group-input-wrap ${className}`}>
      <SelectField
        {...input}
        options={options}
        placeholder={placeholder}
        defaultValue={defaultValue}
        isSearchable={isSearchable}
      />
      {meta.touched && meta.error && (
        <span className="form__form-group-error">{meta.error}</span>
      )}
    </div>
  );
};

renderSelectField.defaultProps = {
  meta: null,
  options: [],
  placeholder: "",
  className: "",
};

export default renderSelectField;
